module.exports = "https://static.weeecdn.net/mweb/_next/static/images/bg-coupon-full-b0fd9d11658095ed41707eba95761d7c.png";